/**
 * Feature Flags - Control de funcionalidades
 * 
 * Permite habilitar/deshabilitar funciones de la aplicación
 * sin necesidad de eliminar código
 */

// ============================================
// 🚩 RISKY FEATURES - Control para revisión de Meta
// ============================================
// Si REACT_APP_ENABLE_RISKY_FEATURES es 'false', se ocultan:
// - Mensajería Masiva (Bulk Messaging)
// - Importación de WhatsApp
// - Cualquier referencia a "Spam" o "Masivo"
// 
// Esto permite tener una versión "limpia" para la revisión de Meta
// y otra "full" para producción.
// ============================================

const RISKY_FEATURES_ENABLED = process.env.REACT_APP_ENABLE_RISKY_FEATURES !== 'false';

export const FEATURE_FLAGS = {
    // Chat en Vivo - Habilitado para Telegram y WhatsApp
    LIVE_CHAT: true,
    
    // Asistente IA - Habilitado
    AI_ASSISTANT:true,
    
    // Otras funcionalidades (habilitadas por defecto)
    MASS_MESSAGING: RISKY_FEATURES_ENABLED,
    INTELLIGENT_FLOWS: true,
    FLOW_ANALYTICS: true,
    SYNONYMS: true,
    AI_ANALYTICS: true,
    
    // 🚩 Risky Features - Controladas por variable de entorno
    BULK_MESSAGING: RISKY_FEATURES_ENABLED,
    WHATSAPP_IMPORT: RISKY_FEATURES_ENABLED,
    CONTACT_IMPORT: RISKY_FEATURES_ENABLED,
};

/**
 * Verificar si una funcionalidad está habilitada
 * @param {string} feature - Nombre de la funcionalidad
 * @returns {boolean}
 */
export const isFeatureEnabled = (feature) => {
    return FEATURE_FLAGS[feature] === true;
};

/**
 * 🚩 Verificar si las funcionalidades "riesgosas" están habilitadas
 * Útil para ocultar secciones completas en la UI
 * @returns {boolean}
 */
export const areRiskyFeaturesEnabled = () => {
    return RISKY_FEATURES_ENABLED;
};

/**
 * Cargar mensajes de mantenimiento desde un archivo externo
 */
let maintenanceMessages = null;

export async function loadMaintenanceMessages() {
    if (maintenanceMessages) {
        return maintenanceMessages;
    }

    try {
        const response = await fetch('/maintenance.json');
        if (!response.ok) {
            throw new Error('No se pudo cargar la configuración de mantenimiento.');
        }
        maintenanceMessages = await response.json();
        return maintenanceMessages;
    } catch (error) {
        console.error('Error al cargar mensajes de mantenimiento:', error);
        return {};
    }
}

/**
 * Obtener un mensaje de mantenimiento específico
 */
export async function getMaintenanceMessage(feature) {
    if (!maintenanceMessages) {
        await loadMaintenanceMessages();
    }
    return maintenanceMessages[feature];
}

/**
 * Mensajes de mantenimiento por defecto
 */
export const MAINTENANCE_MESSAGES = {
    LIVE_CHAT: {
        title: 'Chat en Vivo en Mantenimiento',
        message: 'Estamos mejorando esta funcionalidad. Volverá pronto.',
        icon: '🔧'
    },
    AI_ASSISTANT: {
        title: 'Asistente IA en Mantenimiento',
        message: 'Estamos optimizando el asistente de IA. Volverá pronto.',
        icon: '🤖'
    }
};
